module.exports = __webpack_public_path__ + "static/media/quote-machine-preview.fd9b2068.png";